import RiveWrapper from '../../features/auth/components/RiveWrapper'
import { Logo } from '../../shared/assets/svg'
import { Outlet } from 'react-router'
import { Link } from 'react-router-dom'

const AuthLayout = () => {
  return (
    <main className='h-full min-h-screen bg-primary-70 w-full'>
      <nav className="justify-start h-20 py-2 px-3 mx-auto md:py-2 md:px-6 flex items-center w-full md:w-11/12">
        <Link to="/">
          <Logo />
        </Link>
      </nav>

      <main className="h-full min-h-[calc(100vh-5rem)] flex items-center relative justify-center pb-5">
        <div className="absolute inset-0 z-0">
          <RiveWrapper />
        </div>
        <section className='z-10 h-full w-full flex items-center relative justify-center'>
          <Outlet />
        </section>
      </main>
    </main>
  )
}

export default AuthLayout